export default __webpack_public_path__ + "static/media/nighttime-thunderstorm.0424bb12.jpg";